import * as React from 'react';

export const Checked = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" fillRule="evenodd">
                <path fill="#0EB075" d="M11.983 0C5.376 0 0 5.375 0 11.982c0 6.608 5.376 11.984 11.983 11.984s11.982-5.376 11.982-11.984C23.965 5.375 18.591 0 11.983 0z"/>
                <path stroke="#FFF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.55" d="M16.752 9l-6.573 7.219L7 12.479"/>
            </g>
        </svg>
    );
};

export default Checked;



// WEBPACK FOOTER //
// ./src/Assets/images/svg/checked.tsx